import { Component, Input } from '@angular/core';

@Component({
    selector: 'atx-list-group',
    template: `<ul class="list-group"
    [class.list-group-flush]="isFlush">

    <ng-container *ngIf="hasLink; then withLink else withoutLink"></ng-container>

    <ng-template #withoutLink>
        <li class="list-group-item"
            *ngFor="let element of model">
            {{ element }}
        </li>
    </ng-template>

    <ng-template #withLink>
        <li class="list-group-item"
            *ngFor="let element of model">
            <a [href]="element?.link?.href">
                {{ element?.link?.label }}
            </a>
        </li>
    </ng-template>
</ul>
`,
    styles: [``],
})

export class AtxListGroupComponent {
    @Input() public readonly model;
    @Input() public readonly isFlush: boolean;
    @Input() public readonly hasLink: boolean;
}
